import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type InboxState = {
  inboxUser: number | null;
  inboxTransaction: string | null;
};

const initialState: InboxState = {
  inboxUser: null,
  inboxTransaction: null,
};

const InboxSlice = createSlice({
  name: "inbox",
  initialState,
  reducers: {
    setInboxUser: (state, action: PayloadAction<number | null>) => {
      state.inboxUser = action.payload;
    },
    setInboxTransaction: (state, action: PayloadAction<string | null>) => {
      state.inboxTransaction = action.payload;
    },
  },
});

export const { setInboxUser, setInboxTransaction } = InboxSlice.actions;
export default InboxSlice;
